import es from "date-fns/locale/es";
import { useState } from 'react';
import { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../../_metronic/layout/core';
import * as Utilities from '../../../../Components/Utils/Utils';
import PermissionsGate from '../../../../api/PermissionsGate';
import { SCOPES } from '../../../../config/permissions-map';
import { Unauthorized } from '../../../Global/unauthorized';
import VistaGeneral_indVta from './VistaGeneral_indVta';


function MapaVistaGeneral_indVta({ title }) {
    const lsUnidadEconomica = JSON.parse(sessionStorage.getItem("MapaGeneral_indVta"));
    const lsDate = sessionStorage.getItem("MapaGeneral_indVta_date");

    let dateTemp = new Date();
    const [date, setDate] = useState(lsDate != null ? new Date(lsDate) : new Date(dateTemp.getFullYear(), dateTemp.getMonth() - 1, dateTemp.getDate()));

    let mes = ("0" + (date.getMonth() + 1)).slice(-2);
    let anio = date.getFullYear();
    registerLocale("es", es);

    const [unidadEconomica, setUnidadEconomica] = useState(
        lsUnidadEconomica != null ? lsUnidadEconomica : Utilities.getListUnidadesEconomicas().list[0]
    );
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();
    const getOptionUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeUnidadEconomica = (inputValue) => {
        sessionStorage.setItem("MapaGeneral_indVta", JSON.stringify(inputValue));
        setUnidadEconomica(inputValue);
        // window.location.reload(false);
    }

    const animatedComponents = makeAnimated();

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.MAPA_CALOR_INDICADOR_VENTAS]} >
                <>
                    <PageTitle>{title}</PageTitle>
                    <div className="card my-5">
                        <div className="card-header pt-5 border-0" >


                            <div className="d-flex align-items-center mb-3">
                                <div className="p-2" style={{ minWidth: "200px" }}>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                    <Select
                                        classNamePrefix='filter'
                                        components={animatedComponents}
                                        defaultValue={lsUnidadEconomica != null ? lsUnidadEconomica : getOptionUnidadEconomica(unidadesEconomicasList.defaultId)}
                                        isMulti={false}

                                        closeMenuOnSelect={true}
                                        options={unidadesEconomicasList.list}
                                        onChange={(onChangeUnidadEconomica)}
                                    />
                                </div>

                                {/* <div className='p-2'>
                                        <div className="fw-bold fs-7 text-gray-600 mb-1">Fecha:</div>
                                        <DatePicker
                                            className="form-control form-control-transparent pe-5"
                                            locale="es"
                                            selected={date}
                                            onChange={(dateX) => {
                                                sessionStorage.setItem("MapaGeneral_indVta_date", dateX.getFullYear() + "/" + (dateX.getMonth() + 1) + "/" + dateX.getDate());
                                                return setDate(dateX)
                                            }}
                                            dateFormat="MM/yyyy"
                                            showMonthYearPicker
                                        />
                                    </div> */}
                            </div>


                        </div>

                        <div className="card-body tab-content pt-0">
                            <VistaGeneral_indVta unidadEconomica={unidadEconomica}></VistaGeneral_indVta>

                        </div>
                    </div>
                </>
            </PermissionsGate>
        </>
    )
}

export default MapaVistaGeneral_indVta
